import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { Equipment } from 'src/app/models/maintenance/equipment';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { HttpService, MessageService, params, TableColumns, TableConfiguration } from 'brainloper-ui';

@Component({
    selector: 'app-modal-equipment-form',
    templateUrl: './modal-equipment-form.component.html',
    styleUrls: ['./modal-equipment-form.component.scss'],
    standalone: false
})
export class ModalEquipmentFormComponent implements OnInit {
  public EndpointDictionary = EndpointDictionary;
  public equipments: Equipment[] = [];

  public reloadTableE = new EventEmitter<any>();
  public configurationE: TableConfiguration = {
    selectable: true,
    primaryKey: 'id',
  };
  public columnsE: TableColumns<Equipment>[] = [
    {
      ID: 'code',
      label: 'Codigo',
      type: 'text',
      style: {
        textAlign: 'center'
      }
    },
    {
      ID: 'brand',
      label: 'Marca',
      type: 'text',
      style: {
        textAlign: 'center'
      }
    },
    {
      ID: 'userName',
      label: 'Responsable',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      }
    }
  ];

  public paramsEquipment: params[] = [{ id: 'formId', value: '0' }];

  constructor(
    public dialogRef: MatDialogRef<ModalEquipmentFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private http: HttpService,
    private message: MessageService
  ) {}

  ngOnInit(): void {
    if (this.data.body) {
      this.paramsEquipment = [{ id: 'formId', value: this.data.body.id }];
    }
  }

  selectedEquipment($event: Equipment[]) {
    this.equipments = $event;
  }

  async finalizar() {

    const body = {
      formId: this.data.body.id,
      equipmentIds: this.equipments.map(x => x.id),
    };

    let res: GenericResponse = await this.http.postDataBody(
      `${EndpointDictionary.EquipmentInspectionForm.CRUD_EQUIPMENT_INSPECTION_FORM_DATA}`,
      body
    );
    if (res) {
      this.message.SuccessToast(`Equipo asociada a formulario correctamente`);
      this.dialogRef.close();
    }

    this.dialogRef.close();
  }
}
